import { render, staticRenderFns } from "./WeighingoutGroupReport.vue?vue&type=template&id=20c644da&scoped=true&"
import script from "./WeighingoutGroupReport.vue?vue&type=script&lang=js&"
export * from "./WeighingoutGroupReport.vue?vue&type=script&lang=js&"
import style0 from "./WeighingoutGroupReport.vue?vue&type=style&index=0&id=20c644da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c644da",
  null
  
)

export default component.exports